import React from "react";
import classNames from "classnames";

interface ButtonProps {
  children: React.ReactNode;
  variant?: "default" | "outline";
  size?: "default" | "small" | "xsmall";
  className?: string;
  loadingText?: any;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  loading?: boolean;
}

function Button({
  children,
  variant = "default",
  size = "default",
  className,
  disabled,
  loading,
  loadingText,
  ...otherProps
}: ButtonProps) {
  const classes = classNames(
    " w-80",
    {
      "hover:text-white hover:bg-primary-300 focus:border-primary-500 border border-primary-300":
        variant == "outline" && !disabled && !loading,
      "bg-primary-300 focus:bg-primary-400": variant == "default" && !disabled && !loading,
      "hover:shadow-xl": !disabled,
      "min-w-56 rounded-xl py-4": size == "default",
      "min-w-36 rounded-lg py-2": size == "small",
      "max-w-24 rounded-xl w-24 py-1 ": size == "xsmall",
      "text-white": variant !== "outline",
      "bg-gray-100-mmpz": variant == "default" && disabled || loading,
      "border-gray-100-mmpz border": variant == "outline" && disabled || loading,
    },
    className
  );

  return (
    <button className={classes} {...otherProps} disabled={disabled || loading}>
      {loadingText ? loadingText : children}
    </button>
  );
}

export default Button;
